import axios from "axios";
class ApiShopDiscountCodes {
    static async GetDiscountCodes(session_uuid) {
        try {
            const result = await axios.get("/api/admin/discount-codes/get-list", {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.response;
        }
        catch (e) {
            throw new Error("Error get options");
        }
    }
    static async GetDiscountCodeByUUID(session_uuid, uuid) {
        try {
            const result = await axios.post("/api/admin/discount-codes/get", {
                uuid: uuid
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.response;
        }
        catch (e) {
            return undefined;
        }
    }
    static async CreateDiscountCode(session_uuid, name, active, expires_at, actions, onlyMNP, sendToBss, dontSendToLogistic, nexiTokenization) {
        try {
            const result = await axios.post("/api/admin/discount-codes/create", {
                name: name,
                active: active,
                expires_at: expires_at,
                actions: actions,
                only_mnp: onlyMNP,
                send_to_bss: sendToBss,
                dont_send_to_logistic: dontSendToLogistic,
                nexi_tokenization: nexiTokenization,
                session_uuid: session_uuid,
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.response;
        }
        catch (e) {
            console.error(e);
            if ("response" in e && "data" in e.response && "response" in e.response.data) {
                return e.response.data.response;
            }
        }
        return undefined;
    }
    static async UpdateDiscountCodePublish(publish, session_uuid, uuid) {
        try {
            const result = await axios.post("/api/shop/options/change-option-publish", {
                uuid: uuid,
                publish: publish
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.response;
        }
        catch (e) {
            throw new Error("Error");
        }
    }
    static async UpdateDiscountCodeInfo(session_uuid, uuid, name, active, expires_at, actions, onlyMNP, sendToBss, dontSendToLogistic, nexiTokenization) {
        try {
            const result = await axios.post("/api/admin/discount-codes/update", {
                uuid: uuid,
                name: name,
                active: active,
                expires_at: expires_at,
                actions: actions,
                only_mnp: onlyMNP,
                send_to_bss: sendToBss,
                dont_send_to_logistic: dontSendToLogistic,
                nexi_tokenization: nexiTokenization,
                session_uuid: session_uuid
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.response;
        }
        catch (e) {
            return false;
        }
    }
    static async DeleteDiscountCode(session_uuid, uuid) {
        try {
            const result = await axios.post("/api/admin/discount-codes/delete", {
                uuid: uuid
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.success;
        }
        catch (e) {
            return undefined;
        }
    }
}
export default ApiShopDiscountCodes;
